// @ts-nocheck
import * as types from 'appRedux/actions/login';

const initialState = {
  request: false,
  success: false,
  error: '',
  userData: {},
  logoutResponse: '',
  logoutError: '',
};

function loginReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.USER_LOGIN_REQUEST: {
      return {
        ...state,
        request: true,
        logoutResponse: '',
        logoutError: '',
        userData: {},
        error: '',
      };
    }
    case types.USER_LOGIN_SUCCESS: {
      return {
        ...state,
        request: false,
        success: true,
        logoutResponse: '',
        userData: action.payload ? action.payload : {},
        error: '',
      };
    }

    default: {
      return state;
    }
  }
}

export default loginReducer;
